import React from 'react';
import cx from 'classnames';

import { Tooltip } from '@trqk/components';

import { DataCardRow } from '../components';

interface TopFiveEarningsPerPlayRowProps {
    earningsColor: 'secondary' | 'quarternary';
    earningsFormatted: string;
    index: number;
    show: string;
    source?: Maybe<string>;
}

export const TopFiveEarningsPerPlayRow = (
    props: TopFiveEarningsPerPlayRowProps,
): JSX.Element => {
    const { earningsColor, earningsFormatted, index, source } = props;
    let { show } = props;

    let message = `${source}: ${show}`;

    if (show === 'not_reported' || show === 'not reported') {
        if (source === undefined || source === '') {
            show = 'Unknown show';
            message = show;
        } else {
            show = '';
            message = source ?? '';
        }
    }

    const hasSource = (source?.length ?? 0) > 0;
    const hasShow = show.length > 0;

    const gridTemplateColumns = hasSource && hasShow ? '55px auto' : 'auto';

    return (
        <DataCardRow index={index}>
            <Tooltip message={message} position="bottom" background="light">
                <div
                    className="grid"
                    style={{
                        gridTemplateColumns,
                    }}
                >
                    {hasSource && (
                        <div
                            className={cx('mr-1 truncate', {
                                'font-medium': !hasShow,
                            })}
                        >
                            {source}
                        </div>
                    )}
                    {hasShow && (
                        <div
                            className={cx('truncate', {
                                'font-medium': hasShow,
                            })}
                        >
                            {show}
                        </div>
                    )}
                </div>
            </Tooltip>
            <span className={`ml-2 font-semibold text-${earningsColor}-500`}>
                {earningsFormatted}
            </span>
        </DataCardRow>
    );
};
